module.exports = __webpack_public_path__ + "static/media/5_viewer_presenter.c71b7977.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/5_viewer_presenter.jpg
// module id = 316
// module chunks = 0